/**
 * @param {RootState} state
 * @param {Id} id
 * @returns {Guide}
 */
export const getGuideById = (state, id) => {
    return state.guides.byId[id];
};
